<template>
	<span>{{ mandatedLabel }}</span>
</template>

<script>
	export default {
		name: 'ColumnMandated',
		props: {
			rowData: {
				type: Object,
				required: true
			},
			rowIndex: {
				type: Number
			}
		},
		computed: {
			mandatedLabel() {
				return this.rowData.mandated ? 'Yes' : 'No';
			}
		}
		//Use computed properties instead of data here, otherwise sorting/pagination will break
	}
</script>
